import { useQuery } from "@tanstack/react-query";

import { contactMergeQueryRootKey } from "../config";
import { fetchContactMergeEvents } from "../repo/contactMergeAuditRepo";

/** 按权限和当前任务读取审计时间线。 */
export function useContactMergeAudit(taskId?: number, enabled = false) {
  return useQuery({
    queryKey: [...contactMergeQueryRootKey, "events", taskId],
    queryFn: () => fetchContactMergeEvents(taskId ?? 0),
    enabled: Boolean(taskId && enabled),
  });
}
